module.exports = __webpack_public_path__ + "img/t1-7.7260986a.png";